import { ButtonComponent } from 'components/atoms/button/Button.styles';
import { ButtonProps } from 'components/atoms/button/types';
import styled from 'styled-components';

interface RowProps {
  bottomMargin?: string;
}

///////////////////////////
//Terms Text
///////////////////////////

export const TermsContainer = styled.div``;

export const TermsHeading = styled.p`
  font-weight: bold;
  color: #22c3bb;
  margin-bottom: 16px;
  font-size: 18px;
  text-transform: capitalize;
`;

export const TermsSubHeading = styled.p`
  font-weight: bold;
  color: #22c3bb;
  margin-bottom: 16px;
`;

export const TermsText = styled.p`
  margin-bottom: 16px;
`;

export const TermsList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;

export const TermsRow = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 0 20px;
  align-items: flex-start;
  margin-bottom: ${(props) => props.bottomMargin || '8px'};
`;

export const TermsListLabel = styled.p<{ bold?: boolean }>`
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: #22c3bb;
  min-width: 30px;
  margin-bottom: 8px;
`;

export const TermsListText = styled.p`
  margin-bottom: 8px;
`;

export const TermsSubRow = styled.div<RowProps>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-left: 40px;
  margin-bottom: ${(props) => props.bottomMargin || '8px'};
`;

export const TermsSubLabel = styled.p<{ bold?: boolean }>`
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  margin-left: 20px;
  color: #22c3bb;
  width: 25px;
`;

export const TermsSubText = styled.p`
  flex: 1;
`;

export const TermsTableContainer = styled.div`
  margin-top: 20px;
  padding: 10px 0;
`;

export const TermsTableRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 10px;
  justify-content: space-between;
  border-top: 1px solid #22c3bb;
  border-bottom: 1px solid #22c3bb;
`;

export const TermsTableCell = styled.p<{ bold?: boolean }>`
  width: 50%;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => (props.bold ? '#22C3BB' : 'inherit')};
`;

///////////////////////////
//Dialog
///////////////////////////

export const ScrollableDialogOverlayComponent = styled.div`
  z-index: ${({ theme }) => theme.zIndex.level_5 + 1};
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: 712px;
  max-height: 637px;
  background-color: ${({ theme }) => theme.colours.white};
  transform: translate(-50%, -50%);
  box-shadow: 0 ${({ theme }) => theme.pxToRem(10)} ${({ theme }) => theme.pxToRem(30)} 0
    rgb(0 0 0 / 5%);
  overflow-y: auto;
  border-top: 8px solid #053747;
  border-radius: 0;
`;

export const ScrollableDialogComponent = styled.div`
  &::before {
    z-index: ${({ theme }) => theme.zIndex.level_3};
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgb(0 0 0 / 90%);
    content: '';
  }
`;

export const ScrollableDialogHeading = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing(24)} ${({ theme }) => theme.spacing(32)};
  border-bottom: 2px solid ${({ theme }) => theme.colours.gray};
`;

export const ScrollableDialogClose = styled.button`
  margin-left: auto;
  tab-index: -1;
`;

export const ScrollableDialogTitle = styled.p`
  color: ${({ theme }) => theme.colours.crowberryBlue};
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(20)};
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
`;

export const ScrollableDialogBody = styled.div`
  max-height: 450px;
  padding: ${({ theme }) => theme.spacing(16)} ${({ theme }) => theme.spacing(32)};
  color: ${({ theme }) => theme.colours.charcoalDust};
  overflow-y: scroll;
  scrollbar-width: thin;
  -ms-overflow-style: none;
  z-index: 50;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  font-family: 'Open Sans', serif;
`;

export const ScrollableDialogFooter = styled.div`
  padding: ${({ theme }) => theme.spacing(16)} ${({ theme }) => theme.spacing(32)}
    ${({ theme }) => theme.spacing(24)} ${({ theme }) => theme.spacing(32)};
  border-top: 2px solid ${({ theme }) => theme.colours.gray};
  display: flex;
  justify-content: flex-end;

  button + button {
    margin-left: ${({ theme }) => theme.spacing(20)};
  }
`;

export const DeclineButton = styled.button`
  height: 58px;
  background: #fff;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #053747;
  padding: 0 8px;
  margin-right: 20px;
  color: #053747;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled(ButtonComponent)<ButtonProps & { loading?: boolean }>`
  height: 58px;
  font-size: 16px;
  line-height: 24px;
  padding: ${({ loading }) => (loading ? '0 16px' : '8px 16px')};
  border-radius: 1px;
  width: 136px;
  color: ${({ disabled }) => (disabled ? '#666' : '#fff')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
